import { YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

export const dateRangePickerStyles = ({
  textField: {
    width: '100%',

    '& label': {
      fontSize: YodaFontSize.medium,
      fontWeight: YodaFontWeight.regular,
    },
    '& input': {
      fontSize: YodaFontSize.medium,
      fontWeight: YodaFontWeight.light,
    },
  },
  box: {
    mx: YodaSpacing.small,
  },

});
